<div class="overview-section">
  <div class="overview-heading-wrapper">
    <p class="overview-label">Real-Time Stock Visibility</p>
    <h2 class="overview-heading">Your Stock, In One Dashboard</h2>
    <p class="overview-subtitle">
      Unique items tracked, total units on hand, inventory value, and low stock alerts —
      all live, updated the moment something moves.
    </p>
  </div>

  <div class="overview-frame">
    <img src="images/modules/inventory-overview.PNG" alt="orderYaa Inventory dashboard showing stock levels, low stock alerts, and recent adjustments" />
  </div>
</div>
